// extracted by mini-css-extract-plugin
export default {"wrapper":"Q_ScrollBar_wrapper__PlR7m","track":"Q_ScrollBar_track__TPyeG","scrollbar":"Q_ScrollBar_scrollbar__eSlhU","dragging":"Q_ScrollBar_dragging__IZDzb"};